module.exports = __webpack_public_path__ + "media/svg/cg-3ecee2a9.svg";